<!-- ── Plan card (loaded) ─────────────────────────────────── -->
<div class="plan-card" *ngIf="sidebarPlan && !planLoading" [style.--plan-color]="sidebarPlan.color">

  <!-- Gradient accent bar -->
  <div class="plan-card-accent"></div>

  <div class="plan-card-body">

    <!-- Header row -->
    <div class="plan-top">
      <div class="plan-top-left">
        <div class="plan-eyebrow">Current plan</div>
        <div class="plan-name">{{ sidebarPlan.name }}</div>
        <div class="plan-desc" *ngIf="sidebarPlan.tagline">{{ sidebarPlan.tagline }}</div>
      </div>
      <span class="plan-badge-pill">
        <span class="badge-pulse"></span>Active
      </span>
    </div>

    <!-- Stat chips row -->
    <div class="plan-chips">
      <div class="plan-chip" *ngIf="sidebarPlan.renewalDate">
        <i class="fa-regular fa-calendar"></i>
        <span>{{ sidebarPlan.renewalDate | date: 'MMM d' }}</span>
      </div>
      <div class="plan-chip">
        <i class="fa-regular fa-calendar-check"></i>
        <span>{{ sidebarPlan.bookingLimit === 0 ? '∞' : sidebarPlan.bookingLimit }} bookings</span>
      </div>
      <div class="plan-chip" [class.chip-on]="sidebarPlan.marketplaceEnabled"
        [class.chip-off]="!sidebarPlan.marketplaceEnabled">
        <i class="fa-solid" [class.fa-wifi]="sidebarPlan.marketplaceEnabled"
          [class.fa-wifi-slash]="!sidebarPlan.marketplaceEnabled"></i>
        <span>{{ sidebarPlan.marketplaceEnabled ? 'Marketplace' : 'No market' }}</span>
      </div>
    </div>

    <!-- Listings progress (only if marketplace + limit) -->
    <div class="plan-progress-wrap" *ngIf="sidebarPlan.marketplaceEnabled && sidebarPlan.activeListingLimit > 0">
      <div class="plan-progress-label">
        <span>Listings</span>
        <span class="plan-progress-count">{{ sidebarPlan.activeListings }} / {{ sidebarPlan.activeListingLimit }}</span>
      </div>
      <div class="plan-progress-track">
        <div class="plan-progress-fill" [style.width.%]="sidebarPlan.listingPercent"
          [class.progress-warn]="sidebarPlan.listingPercent >= 80"></div>
      </div>
    </div>

  </div>

</div>

<!-- ── Skeleton ──────────────────────────────────────────────── -->
<div class="plan-card plan-card--skeleton" *ngIf="planLoading">
  <div class="plan-card-accent"></div>
  <div class="plan-card-body">
    <div class="plan-top">
      <div class="plan-top-left">
        <div class="skel skel--eyebrow"></div>
        <div class="skel skel--name"></div>
        <div class="skel skel--desc"></div>
      </div>
      <div class="skel skel--badge"></div>
    </div>
    <div class="plan-chips">
      <div class="skel skel--chip"></div>
      <div class="skel skel--chip"></div>
      <div class="skel skel--chip"></div>
    </div>
  </div>
  <div class="plan-card-footer">
    <div class="skel skel--btn"></div>
  </div>
</div>

<!-- ── Manage Subscription Modal ────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalOpen" (click)="closeModal()">
  <div class="modal-sheet" (click)="$event.stopPropagation()">

    <div class="modal-header">
      <div class="modal-header-left">
        <div class="modal-header-icon" [style.background]="(sidebarPlan?.color ?? '#0ea5e9') + '18'"
          [style.color]="sidebarPlan?.color ?? '#0ea5e9'">
          <i class="fa-solid fa-layer-group"></i>
        </div>
        <div>
          <div class="modal-title">Manage subscription</div>
          <div class="modal-subtitle" *ngIf="sidebarPlan">{{ sidebarPlan.name }} plan</div>
        </div>
      </div>
      <button class="modal-x" (click)="closeModal()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="modal-body" *ngIf="sidebarPlan">

      <!-- Current subscription -->
      <!-- Upgrade CTA -->
      <div class="modal-section">
        <div class="section-label">Ready to grow?</div>
        <div class="upgrade-cta-block">
          <div class="upgrade-cta-text">
            <i class="fa-solid fa-arrow-trend-up"></i>
            <div>
              <div class="upgrade-cta-title">Explore available plans</div>
              <div class="upgrade-cta-sub">
                Compare features, pricing and find the right plan for your business.
              </div>
            </div>
          </div>
          <button class="upgrade-cta-btn" (click)="navigateToUpgrade()">
            View plans <i class="fa-solid fa-arrow-right"></i>
          </button>
        </div>
      </div>
      <!-- Plan features -->
      <div class="modal-section">
        <div class="section-label">Plan features</div>
        <div class="feature-grid">
          <div class="feature-item">
            <span class="feature-icon-wrap"><i class="fa-regular fa-calendar-check"></i></span>
            {{ sidebarPlan.bookingLimit === 0 ? 'Unlimited' : sidebarPlan.bookingLimit }} bookings / cycle
          </div>
          <div class="feature-item">
            <span class="feature-icon-wrap"><i class="fa-solid fa-tag"></i></span>
            Listing fee: {{ sidebarPlan.listingFee === 0 ? 'Free' : 'AED ' + sidebarPlan.listingFee }}
          </div>
          <div class="feature-item">
            <span class="feature-icon-wrap">
              <i class="fa-solid" [class.fa-wifi]="sidebarPlan.marketplaceEnabled"
                [class.fa-wifi-slash]="!sidebarPlan.marketplaceEnabled"></i>
            </span>
            Marketplace {{ sidebarPlan.marketplaceEnabled ? 'active' : 'inactive' }}
          </div>
          <div class="feature-item">
            <span class="feature-icon-wrap"><i class="fa-solid fa-list"></i></span>
            {{ sidebarPlan.activeListingLimit === 0 ? 'Unlimited' : sidebarPlan.activeListingLimit }} listing slots
          </div>
          <div class="feature-item">
            <span class="feature-icon-wrap"><i class="fa-solid fa-database"></i></span>
            {{ sidebarPlan.storageLimitGb === 0 ? 'Unlimited' : sidebarPlan.storageLimitGb + ' GB' }} storage
          </div>
          <div class="feature-item">
            <span class="feature-icon-wrap">
              <i class="fa-solid fa-box"></i>
            </span>
            {{ sidebarPlan.addOnBookingEnabled ? 'Add-on packs available' : 'No add-on packs' }}
          </div>
        </div>
      </div>

      <!-- Current usage -->
      <div class="modal-section">
        <div class="section-label">Current usage</div>
        <div class="usage-grid">
          <div class="usage-cell">
            <div class="usage-num">{{ usageData.bookingsUsed }}</div>
            <div class="usage-sub">Bookings used</div>
          </div>
          <div class="usage-cell">
            <div class="usage-num">{{ usageData.bookingsRemaining }}</div>
            <div class="usage-sub">Remaining</div>
          </div>
          <div class="usage-cell">
            <div class="usage-num">{{ usageData.daysUntilRenewal }}</div>
            <div class="usage-sub">Days to renewal</div>
          </div>
          <div class="usage-cell">
            <div class="usage-num">{{ sidebarPlan.activeListings }}</div>
            <div class="usage-sub">Active listings</div>
          </div>
          <div class="usage-cell">
            <div class="usage-num">{{ usageData.totalVehicles }}</div>
            <div class="usage-sub">Total vehicles</div>
          </div>
          <div class="usage-cell">
            <div class="usage-num">{{ usageData.storageUsedGb }} GB</div>
            <div class="usage-sub">Storage used</div>
          </div>
        </div>
      </div>

      <!-- Ready to grow? (replaces old "Available plans" compare grid) -->
      <div class="modal-section">
        <div class="section-label">Ready to grow?</div>
        <div class="upgrade-cta-block">
          <div class="upgrade-cta-text">
            <i class="fa-solid fa-arrow-trend-up"></i>
            <div>
              <div class="upgrade-cta-title">Explore available plans</div>
              <div class="upgrade-cta-sub">
                Compare features, pricing and find the right plan for your business.
              </div>
            </div>
          </div>
          <button class="upgrade-cta-btn" (click)="navigateToUpgrade()">
            View plans <i class="fa-solid fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <!-- Billing -->
      <div class="modal-section">
        <div class="section-label">Billing information</div>
        <div class="info-grid">
          <div class="info-cell">
            <div class="ic-label">Renewal date</div>
            <div class="ic-value">{{ sidebarPlan.renewalDate | date:'MMM d, y' }}</div>
          </div>
          <div class="info-cell">
            <div class="ic-label">Term</div>
            <div class="ic-value">{{ sidebarPlan.term | titlecase }}</div>
          </div>
          <div class="info-cell">
            <div class="ic-label">Auto-renewal</div>
            <div class="ic-value">Enabled</div>
          </div>
          <div class="info-cell" style="cursor:pointer" (click)="navigateToInvoices()">
            <div class="ic-label">Invoices</div>
            <div class="ic-value ic-link">View all invoices →</div>
          </div>
        </div>
      </div>

    </div>

    <div class="modal-footer">
      <button class="btn-secondary" (click)="closeModal()">Close</button>
      <button class="btn-primary" (click)="navigateToUpgrade()">
        Upgrade plan <i class="fa-solid fa-arrow-right"></i>
      </button>
    </div>
  </div>
</div>